import dayjs from "dayjs";

export const makeTimeSorter = (field) => (a, b) => {
  const toMillis = (record) => {
    const value = record?.[field];
    if (!value) return null;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.valueOf() : null;
  };
  const first = toMillis(a);
  const second = toMillis(b);
  if (first == null && second == null) return 0;
  if (first == null) return 1;
  if (second == null) return -1;
  return first - second;
};

export const TIME_SORT_DIRECTIONS = ["ascend", "descend"];
